import {
  AfterContentInit,
  ChangeDetectorRef,
  ContentChild,
  Directive,
  HostBinding,
  OnDestroy,
  Renderer2
} from '@angular/core';

import { BreakpointService } from '../../services/breakpoint.service';
import { BottomSwipeSheetDirective } from './bottom-swipe-sheet.directive';
import { OverlaySwipeDirective } from './overlay-swipe.directive';

@Directive({
    selector: '[appModalSwipe]',
    standalone: true
})
export class ModalSwipeDirective implements AfterContentInit, OnDestroy {
  constructor(
    public breakPoint: BreakpointService,
    private renderer: Renderer2,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  @HostBinding('class.is-open') toggle: boolean = false;

  @ContentChild(BottomSwipeSheetDirective) bottomSwipeSheet: BottomSwipeSheetDirective;
  @ContentChild(OverlaySwipeDirective) overlaySwipe: OverlaySwipeDirective;

  ngAfterContentInit(): void {
    if (this.breakPoint.isMobile) {
      this.renderer.addClass(document.documentElement, 'is-scroll');

      setTimeout(() => {
        this.toggle = !this.toggle;
        this.changeDetectorRef.markForCheck();
      }, 300);
    }
  }

  hideModal(direction?: 'up' | 'down' | 'left' | 'right'): void {
    this.bottomSwipeSheet.swipeModal(direction);
    this.overlaySwipe.fadeOverlay();
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.documentElement, 'is-scroll');
  }
}
